<section
  *ngIf="{
    selectedBanner: selectedBanner$ | async,
    selectedBannerPropertyPath: selectedBannerPropertyPath$ | async,
    canUserInteract: canUserInteract$ | async,
    violations: violations$ | async
  } as STATE"
  class="edit-banner-form"
>
  <header>
    <ng-container *ngIf="$any(STATE.selectedBanner)?.data as banner">
      <img
        *ngIf="banner.attachment.contentType !== attachmentType.video"
        [src]="
          banner.attachment.publicUrl || 'assets/images/image-placeholder.png'
        "
        alt="attachment_logo"
      />
      <video
        *ngIf="banner.attachment.contentType === attachmentType.video"
        [muted]="true"
        loop
        autoplay="autoplay"
        [src]="banner.attachment.publicUrl"
      ></video>
    </ng-container>
    <mat-error *ngIf="form.getError('httpError') as httpError">
      <strong>{{ httpError }}</strong>
    </mat-error>
    <div *ngIf="STATE.selectedBanner?.data as data">
      <h6>{{ data.attachment?.filename }}</h6>
      <p *ngIf="data.createdAt">
        Crée le {{ data.createdAt | date: 'dd/MM/yyyy à HH:mm' : '' : 'fr' }}
      </p>
      <button
        (click)="removeBanner()"
        [disabled]="!STATE.canUserInteract"
        class="btn btn--link-red"
      >
        {{
          STATE.selectedBanner?.data?.id
            ? 'Supprimer définitivement'
            : 'Supprimer'
        }}
      </button>
    </div>
  </header>

  <!-- <form
    *ngIf="STATE.selectedBanner && STATE.selectedBannerPropertyPath"
    [formGroup]="form"
    [ngxsForm]="STATE.selectedBannerPropertyPath"
    class="resource-form"
  > -->
  <!-- <article>
      <mat-label>Programme *</mat-label>
      <mat-form-field>
        <div matPrefix class="custom-prefix">
          <img src="assets/icons/tag-grey.svg" alt="" />
        </div>
        <mat-select formControlName="relatedObjectIdentifier">
          <mat-option
            *ngFor="let item of program ? [program] : []"
            [value]="item.id"
          >
            {{ item.name }}
          </mat-option>
        </mat-select>
        <div matSuffix class="custom-suffix">
          <img src="assets/icons/unfold-more.svg" alt="" />
        </div>
      </mat-form-field>
      <mat-error
        *ngIf="
          form
            .get('relatedObjectIdentifier')
            ?.getError('httpError') as httpError
        "
      >
        <strong>{{ httpError }}</strong>
      </mat-error>
    </article> -->

  <!-- <article>
      <mat-label>Titre de la bannière *</mat-label>
      <mat-form-field>
        <input
          formControlName="title"
          matInput
          placeholder="Entrez un titre (200 charactères max)."
        />
      </mat-form-field>
      <mat-error *ngIf="form.get('title')?.getError('httpError') as httpError">
        <strong>{{ httpError }}</strong>
      </mat-error>
    </article>

    <article>
      <mat-label>Couleur du titre</mat-label>
      <color-picker-bar
        (colorChange)="setColor($event)"
        [colors]="colors"
        [defaultColor]="defaultColor"
      ></color-picker-bar>
      <mat-error
        *ngIf="form.get('titleColor')?.getError('httpError') as httpError"
      >
        <strong>{{ httpError }}</strong>
      </mat-error>
    </article>

    <article>
      <mat-label>Description de la bannière *</mat-label>
      <mat-form-field>
        <textarea
          formControlName="description"
          matInput
          rows="5"
          placeholder="Entrez la description à afficher (200 charactères max)."
        ></textarea>
      </mat-form-field>
      <mat-error
        *ngIf="form.get('description')?.getError('httpError') as httpError"
      >
        <strong>{{ httpError }}</strong>
      </mat-error>
    </article>

    <article>
      <mat-label>Couleur de la description</mat-label>
      <color-picker-bar
        (colorChange)="setColor($event)"
        [colors]="colors"
        [defaultColor]="defaultColor"
      ></color-picker-bar>
      <mat-error
        *ngIf="form.get('descriptionColor')?.getError('httpError') as httpError"
      >
        <strong>{{ httpError }}</strong>
      </mat-error>
    </article>
  </form> -->

  <p *ngIf="!STATE.selectedBanner" class="edit-banner-form__unselected">
    Aucune bannière sélectionnée
  </p>
</section>
